export const formatPhone = (countryCode: any, phoneNumber?: any) => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  if (!countryCode || countryCode === '+1') {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  }

  return `${countryCode} ${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
};

export const isPhoneNumber = (value: any) => {
  return /^\d{10}$/.test(value);
};
